import RecordTemplate               from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateId             from "../../../../domain/record/template/RecordTemplateId";
import RecordTemplateName           from "../../../../domain/record/template/RecordTemplateName";
import RecordTemplateRepository     from "../../../../domain/record/template/RecordTemplateRepository";
import RecordTemplates              from "../../../../domain/record/template/RecordTemplates";
import WidgetItem                   from "../../../../domain/record/widget/item/WidgetItem";
import WidgetItemTitle              from "../../../../domain/record/widget/item/WidgetItemTitle";
import Widget                       from "../../../../domain/record/widget/Widget";
import WidgetTitle                  from "../../../../domain/record/widget/WidgetTitle";
import { ApiClient }                from "../../../configure/ApiClientConfig";
import {
  addRecordTemplateWidgetAction,
  addRecordTemplateWidgetItemAction,
  deleteRecordTemplateWidgetAction,
  deleteRecordTemplateWidgetItemAction,
  moveRecordTemplateWidgetAction,
  setRecordTemplateAction,
  setRecordTemplateNameAction,
  setRecordTemplateWidgetItemTitleAction,
  setRecordTemplateWidgetTitleAction
}                                   from "../../../redux/record/template/RecordTemplateAction";
import { setRecordTemplatesAction } from "../../../redux/record/template/RecordTemplatesAction";

class RecordTemplateDataSource implements RecordTemplateRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  addWidget(widget: Widget) {
    this.dispatch(addRecordTemplateWidgetAction(widget));
  }

  addWidgetItem(widgetIndex: number, widgetItem: WidgetItem) {
    this.dispatch(addRecordTemplateWidgetItemAction(widgetIndex, widgetItem));
  }


  delete(id: RecordTemplateId) {
    return ApiClient.delete("/record/template", {
      params: {
        id: id.value
      }
    })
  }

  deleteWidget(widgetIndex: number) {
    this.dispatch(deleteRecordTemplateWidgetAction(widgetIndex));
  }

  deleteWidgetItem(widgetIndex: number, widgetItemIndex: number) {
    this.dispatch(deleteRecordTemplateWidgetItemAction(widgetIndex, widgetItemIndex));
  }


  findAll() {
    return ApiClient.get("/record/templates");
  }

  findBy(id: RecordTemplateId) {
    return ApiClient.get("/record/template", {
      params: {
        id: id.value
      }
    })
  }

  moveWidget(widgetIndex: number, widget: Widget) {
    this.dispatch(moveRecordTemplateWidgetAction(widgetIndex, widget));
  }

  save(template: RecordTemplate) {
    return ApiClient.post("/record/template", {
      name: template.name.value,
      widgets: template.widgets.toList().map(widget => ({
        type: widget.type.value,
        title: widget.title.value,
        value: "",
        coordinate: {
          x: widget.coordinate.x,
          y: widget.coordinate.y
        },
        items: widget.items.toList().map(item => ({
          title: item.title.value,
          value: "",
        }))
      }))
    });
  }

  setWidgetItemTitle(widgetIndex: number, widgetItemIndex: number, widgetItemTitle: WidgetItemTitle) {
    this.dispatch(setRecordTemplateWidgetItemTitleAction(widgetIndex, widgetItemIndex, widgetItemTitle));
  }

  setWidgetTitle(widgetIndex: number, widgetTitle: WidgetTitle) {
    this.dispatch(setRecordTemplateWidgetTitleAction(widgetIndex, widgetTitle));
  }

  update(template: RecordTemplate) {
    return ApiClient.put("/record/template", {
      id: template.id.value,
      name: template.name.value,
      widgets: template.widgets.toList().map(widget => ({
        type: widget.type.value,
        title: widget.title.value,
        value: "",
        coordinate: {
          x: widget.coordinate.x,
          y: widget.coordinate.y
        },
        items: widget.items.toList().map(item => ({
          title: item.title.value,
          value: "",
        }))
      }))
    });
  }

  setTemplate(template: RecordTemplate) {
    this.dispatch(setRecordTemplateAction(template));
  }

  setTemplates(templates: RecordTemplates) {
    this.dispatch(setRecordTemplatesAction(templates));
  }

  setTemplateName(name: RecordTemplateName) {
    this.dispatch(setRecordTemplateNameAction(name));
  }

  initialize() {
    this.dispatch(setRecordTemplateAction(new RecordTemplate()));
  }
}

export default RecordTemplateDataSource;
